import { metrics } from '@atlassian/browser-metrics';

export const devPanelTimeToLoad = metrics.interaction({
	key: 'devPanelApp.time-to.load',
	// @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
	histogram: {
		result: '300_1000_2500_4000_7000_10000',
	},
});
